import {
  GAME_REDIRECT_SET,
  PAGE_SET,
  SEARCH_SET,
  SPORTSMEN_REDUCER_RESET,
} from "../../Core/myResultsActions";
import { RANKING_SET } from "../../Ranking/rankingReducer";

const MARK_SPORTSMEN = "MARK_SPORTSMEN";
const RESET_MARKED_SPORTSMEN = "RESET_MARKED_SPORTSMEN";
const MARK_CLASSIFICATION_TEAMS = "MARK_CLASSIFICATION_TEAMS";
const DEFAULT_STATE = { sportsmen: [], teams: [], classificationTeams: [] };

export const markedSportsmenReducer = (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case GAME_REDIRECT_SET:
        case SEARCH_SET:
        case PAGE_SET:
        case RANKING_SET:
        case RESET_MARKED_SPORTSMEN:
        case SPORTSMEN_REDUCER_RESET:
            return DEFAULT_STATE;
        case MARK_SPORTSMEN:
            return action.payload;
        case MARK_CLASSIFICATION_TEAMS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export const resetSportsmenReducer = () => {
  return {
    type: SPORTSMEN_REDUCER_RESET,
    payload: null,
  };
};

export const markSportsmenAction = (sportsmenIds, teamIds) => {
  return {
    type: MARK_SPORTSMEN,
    payload: {
      sportsmen: sportsmenIds,
      teams: teamIds,
    },
  };
};

export const markClassificationTeamsAction = (classificationTeams) => {
  return {
    type: MARK_CLASSIFICATION_TEAMS,
    payload: {
      classificationTeams,
    },
  };
};
